/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_Cta_BtnInputs */

const en_fw_tpl_cta_btn = /** @type {(inputs: Fw_Tpl_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free`)
};

const id_fw_tpl_cta_btn = /** @type {(inputs: Fw_Tpl_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai gratis`)
};

/**
* | output |
* | --- |
* | "Start free" |
*
* @param {Fw_Tpl_Cta_BtnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_cta_btn = /** @type {((inputs?: Fw_Tpl_Cta_BtnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_Cta_BtnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_cta_btn(inputs)
	return en_fw_tpl_cta_btn(inputs)
});